import React, { useState } from "react"
import { navigate, Link } from 'gatsby'

import { toast } from 'react-toastify'
import Loading from "../../components/Loading"
import ShareComponent from './../ShareComponent'

import Download from './../../images/icons/download.png'
import VideoFile from './../../images/icons/video-file.png'
import AudioFile from './../../images/icons/audio-file.png'
import TextFile from './../../images/icons/text-file.png'
import FileFile from './../../images/icons/file-file.png'
import Folder from './../../images/icons/folder.png'
import Empty from './../../images/icons/empty.png'
import Share from './../../images/icons/share.png'

import { apiCall, validateToken, url_base, server, detectFileType, removeStyles } from './../../../Helper'
import { useEffect } from "react"

export default ({ id }) => {
  if (!id) navigate('/files/list')
  const [isLoading, setIsLoading] = useState(false)
  const [file, setFile] = useState({})
  const [fileType, setFileType] = useState('file')
  const [showShare, setShowShare] = useState(false)

  function getFile() {
    setIsLoading(true)
    apiCall({
      url: '/tutorials/files',
      params: { file_id: id }
    }).then(res => {
      setIsLoading(false)
      if (res && res.data) {
        if (!res.data.code)
          setFile({ ...res.data, file: url_base + '/' + res.data.file.replace(server, '') })
        else setFile({})
        res.data.msg && toast.error(res.data.msg)

        setFileType(detectFileType(res.data.file))

        setTimeout(() => {
          removeStyles("#desc")
        }, 100);
      }
    }).catch(err => { toast.error('مشکل در سیستم'); setIsLoading(false) })
  }

  function getShareText(tg) {
    return (
      `دیجی مالیات برترین سامانه تخصصی قوانین و مقررات کشور
      
      ${window.location.href}
      
      
      ${file.name}
      
      
      https://instagram.com/digimaliat`
    )
  }
  function getMailText() {
    return (
      `دیجی مالیات برترین سامانه تخصصی قوانین و مقررات کشور
      %0A%0A
      ${window.location.href}
      %0A%0A
      ${file.name}
      %0A%0A
      https://instagram.com/digimaliat`
    )
  }

  useEffect(() => {
    validateToken()
    getFile()
  }, [id])

  return (
    <div>
      <h3 className="m-0 text-shadow font-16 pr-16">فایل</h3>
      <hr className="mb-0" />
      {file.id ? <div className="grid" style={{ gridTemplateColumns: '7fr 2fr' }}>

        <div className="p-32">
          {/* title */}
          <div className="flexed justify-between pb-32" style={{ alignItems: 'baseline' }}>
            <h4 className="mt-0 text-shadow font-14 flex-1">{file.name}</h4>

            <div className="flexed pr-32">
              {showShare &&
                <ShareComponent getShareText={getShareText} getMailText={getMailText}
                  className="flexed slideInBottom absolute"
                  style={{ bottom: 'calc(-30% - 32px)', right: '-50%' }} />}
              <button className="bd-none bg-none icon-button mx-8 p-0" title="اشتراک گذاری" onClick={() => setShowShare(!showShare)}>
                <img className="icon-sm valign-mid button" src={Share} alt="" />
              </button>
            </div>
          </div>

          {/* the file */}
          {file.file &&
            (fileType === 'video' || fileType === 'audio') ? <div className="bg-tomato-lighter mt-32" style={{ minHeight: 320 }}>
            {fileType === 'video' && <video className="w-100" src={file.file} controls controlsList="nodownload" />}
            {fileType === 'audio' && <audio className="w-100" src={file.file} controls controlsList="nodownload" />}
          </div> :
            fileType === 'text' ? <iframe className="w-100" style={{ height: 512 }} src={file.file} /> :
              (fileType === 'image' && <img className="w-100 force" src={file.file} />)
          }

          {file.sub_title && <h5 className="pt-8 font-12">{file.sub_title}</h5>}
          {file.description && <div id="desc" dangerouslySetInnerHTML={{ __html: file.description }} />}
          <div className="flexed justify-between align-c">
            <span className="font-10">آپلود شده در تاریخ {file.submit_date?.slice(0, 16)}</span>
            {/* <a href={file.file} style={{ width: 32 }} target="_blank">
              <img src={Download} alt="" />
            </a> */}
          </div>
        </div>

        {/* related files */}
        <div>
          {file.related && file.related.length > 0 && <div className="radius-4 p-16 text-center mt-32" style={{ backgroundColor: 'rgba(255, 255, 255, .5)' }}>
            <h5 className="m-0">
              <span className="bg-tomato ml-4 icon-mask inline-blocked" style={{
                WebkitMaskImage: `url(${Folder})`,
                WebkitMaskSize: 'contain',
                height: 24, width: 24, marginBottom: -8
              }} />
                فایل های مرتبط
              </h5>
            <hr className="my-16" />
            <div className="grid overflow-auto" style={{ gridRowGap: 8, maxHeight: 256, gridTemplateColumns: '1fr' }}>
              {
                file.related.map((file, index) => {
                  return (
                    <button key={index} className="bd-none bg-none mx-8 p-0 iran-sans one-line">
                      <Link to={`/files/list/${file.id}`} target="_blank" className="flexed" style={{ alignItems: 'flex-start' }}>
                        <img src={
                          detectFileType(file.ext) === 'video' ? VideoFile :
                            detectFileType(file.ext) === 'audio' ? AudioFile :
                              detectFileType(file.ext) === 'text' ? TextFile : FileFile
                        } alt="" className="mb-16 p-8" style={{ width: 52 }} />
                        <div className="grid flex-1 text-right pt-12">
                          <span className="font-13 mb-4">{file.name}</span>
                          <span className="ltr font-10 iran-sans-light">{file.sub_title?.slice(0, 32)}</span>
                        </div>
                      </Link>
                    </button>
                  )
                })
              }
            </div>
          </div>}
        </div>
      </div> : (!isLoading && <div className="pt-45">
        <div className="pt-45">
          <img src={Empty} alt="" className="blocked mx-auto" style={{ width: 128 }} />
        </div>
        <div>
          <h3 className="text-center pt-16">
            <span className="font-18">کاربر گرامی</span>
            <br />
            <span className="blocked pt-12">این فایل را خریداری نکرده اید</span>
            <br />
            <a href={"https://digimaliat.ir/shop/file/" + id}>
              <button className="bd-none bg-none icon-button iran-sans radius-4 font-14 text-top-nav"
                style={{ color: 'var(--tomato)', padding: '8px 0', width: 230, border: '1px solid var(--tomato)' }}>لینک خرید</button>
            </a>
          </h3>
        </div>
      </div>)}
      <Loading show={isLoading} full />
    </div>
  )
}
